import { Card, CardContent, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import axiosInstance from "../utilities/Axios";
import { useTheme } from "../Hooks/ThemeContext/ThemeContext";
import { useDuration } from "../Hooks/DurationContext/DurationContext";
import moment from "moment";
import { getDateRangePickerDayUtilityClass } from "@mui/x-date-pickers-pro";
import { DashboardStat } from "../Components/Stats/DashStat";
import Scaffold from "../Components/Layout/Scaffold";

const Dashboard = () => {
  const duration = useDuration();
  const limit = 10;
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const theme = useTheme();
  const [resumeCount, setResumeCount] = useState<number>(0);
  const [countryProcessCount, setCountryProcessCount] = useState<number>(0);
  const [todayTicketCount, setTodayTicketCount] = useState<number>(0);
  const [processCount, setProcessCount] = useState<number>(0);
  const [completedProcessCount, setCompletedProcessCount] = useState<number>(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const getDateRange = (duration: any) => {
    const today = moment();
    let fromDate, toDate;

    switch (duration.duration) {
      case "week":
        fromDate = today.clone().startOf("week");
        toDate = today.clone().endOf("week");
        break;
      case "month":
        fromDate = today.clone().startOf("month");
        toDate = today.clone().endOf("month");
        break;
      case "last30":
        fromDate = today.clone().subtract(29, "days");
        toDate = today.clone();
        break;
      case "lastMonth":
        fromDate = today.clone().subtract(1, "month").startOf("month");
        toDate = today.clone().subtract(1, "month").endOf("month");
        break;
      case "last03":
        fromDate = today.clone().subtract(2, "months").startOf("month");
        toDate = today.clone();
        break;
      case "year":
        fromDate = today.clone().subtract(1, "year").startOf("year");
        toDate = today.clone().subtract(1, "year").endOf("year");
        break;
      default:
        fromDate = today.clone().startOf("week");
        toDate = today.clone().endOf("week");
    }

    const formattedFromDate = fromDate.format("YYYY-MM-DD");
    const formattedToDate = toDate.format("YYYY-MM-DD");

    setFromDate(formattedFromDate);
    setToDate(formattedToDate);

    return { formattedFromDate, formattedToDate };
  };

  // useEffect(() => {
  //   getAllList();
  // }, [duration]);

  useEffect(() => {
    getDateRange(duration);
  }, [duration]);

  const getAllList = async () => {
    try {
      const response = await axiosInstance.get(
        `/v1/dashboard?type_dom_corp=${theme.theme}&from=${fromDate}&to=${toDate}`,
        {}
      );
      const data = response.data;

      setResumeCount(data.result.resume_count);
      setCountryProcessCount(data.result.country_processCount);
      setTodayTicketCount(data.result.todays_ticketCount);
      setProcessCount(data.result.processCount);
      setCompletedProcessCount(data.result.completed_processCount);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const { formattedFromDate, formattedToDate } = getDateRange(duration);

    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(
          `/v1/dashboard?type_dom_corp=${theme.theme}&from=${formattedFromDate}&to=${formattedToDate}`,
          {}
        );
        const data = response.data;
        setResumeCount(data.result.resume_count);
        setCountryProcessCount(data.result.country_processCount);
        setTodayTicketCount(data.result.todays_ticketCount);
        setProcessCount(data.result.processCount);
        setCompletedProcessCount(data.result.completed_processCount);
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [duration]);

  return (
    <Scaffold
    title="Dashboard"
    actions={[]}
    mainAction={null}
    >
      <div>
          <Typography sx={{ fontSize: 20, fontWeight: 'semi-bold' }}>
            Overview
          </Typography>
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 my-3">
            <DashboardStat title="Country Processes" data={countryProcessCount} color="info.main" />
            <DashboardStat title="Resumes" data={resumeCount} color="warning.main" />
            <DashboardStat title="Today Tickets" data={todayTicketCount} color="secondary.main" />
          </div>
          <Typography sx={{ fontSize: 20, fontWeight: 'semi-bold' }}>
            Processes
          </Typography>
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 mt-2">
            <DashboardStat title="Processing" data={processCount} color="primary.main" />
            <DashboardStat title="Completed" data={completedProcessCount} color="success.main" />
          </div>
        </div>
    </Scaffold>
  );
};

export default Dashboard;
